import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = { class: "row mt-2" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "table table-hover align-middle" }
const _hoisted_7 = { class: "border-dark border-bottom pb-2" }
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = {
  key: 0,
  class: "col-1"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { class: "ms-2" }
const _hoisted_13 = {
  key: 0,
  class: "col-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCardHeader = _resolveComponent("BaseCardHeader")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_BasePlaceholderTable = _resolveComponent("BasePlaceholderTable")!
  const _component_BaseCardBody = _resolveComponent("BaseCardBody")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_ctx.AbilityContext.isAuthorizedForFeature('BACK_IN_STOCK_NOTIFICATION') && _ctx.AuthContext.isDpUser())
    ? (_openBlock(), _createBlock(_component_BaseCard, {
        key: 0,
        class: "text-bg-light border-light mb-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseCardHeader, { class: "p-2" }, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('backInStockNotifications')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BaseCardBody, { class: "p-2" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_InputCheckboxBoolean, {
                    modelValue: _ctx.onlyOpen,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyOpen) = $event)),
                    label: _ctx.$t('onlyOpenNotifications'),
                    name: "expect_products_in_subcategory",
                    class: "mb-4",
                    errors: _ctx.sliderErrors
                  }, null, 8, ["modelValue", "label", "errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("table", _hoisted_6, [
                    _createElementVNode("thead", _hoisted_7, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('email')), 1),
                        (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_SHARED_CATALOG_SETTINGS'))
                          ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_ctx.$t('pharmacy')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_ctx.componentUI.isNotReady())
                        ? (_openBlock(), _createBlock(_component_BasePlaceholderTable, {
                            key: 0,
                            "n-cols": _ctx.AbilityContext.isAuthorizedForFeature('MGMT_SHARED_CATALOG_SETTINGS') ? 2 : 1
                          }, null, 8, ["n-cols"]))
                        : (_ctx.componentUI.isReady() && !_ctx.notificationRequestsToDisplay.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                              _createElementVNode("td", {
                                colspan: _ctx.AbilityContext.isAuthorizedForFeature('MGMT_SHARED_CATALOG_SETTINGS') ? 2 : 1,
                                class: "fw-bold small text-uppercase text-muted"
                              }, _toDisplayString(_ctx.$t('noResults')), 9, _hoisted_11)
                            ]))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.notificationRequestsToDisplay, (notificationRequest, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(notificationRequest.client_email), 1)
                                ]),
                                (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_SHARED_CATALOG_SETTINGS'))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                                      _createElementVNode("div", null, _toDisplayString(notificationRequest.pharmacy?.description) + "% ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}